import React from 'react';
import { Flex } from '@atlaskit/primitives/compiled';
import Button, { IconButton } from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import CloseIcon from '@atlaskit/icon/core/close';
import { useIntl } from '@atlassian/jira-intl';
import type { Props } from './types.tsx';
import messages from './messages.tsx';

const styles = cssMap({
	container: {
		backgroundColor: token('color.background.accent.gray.subtlest'),
		borderRadius: token('border.radius', '3px'),
		paddingTop: token('space.100'),
		paddingRight: token('space.100'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.100'),
		marginBottom: token('space.negative.200', '-18px'),
		marginRight: token('space.negative.200', '-18px'),
		marginLeft: token('space.negative.200', '-18px'),
	},
});

export const DescriptionCompleter = (props: Props) => {
	const { onClick, onClose } = props;
	const { formatMessage } = useIntl();
	return (
		<Flex
			justifyContent="space-between"
			testId="ai-proactive-description-completer.ui.description-completer.container"
			xcss={styles.container}
		>
			<Button
				appearance="default"
				spacing="compact"
				iconBefore={AtlassianIntelligenceIcon}
				onClick={onClick}
				testId="ai-proactive-description-completer.ui.description-completer.generate-button"
			>
				{formatMessage(messages.summarizeLinkContent)}
			</Button>
			<IconButton
				appearance="subtle"
				spacing="compact"
				icon={CloseIcon}
				label={formatMessage(messages.closeFooter)}
				onClick={onClose}
				testId="ai-proactive-description-completer.ui.description-completer.close-button"
			/>
		</Flex>
	);
};
